module.exports = __webpack_public_path__ + "img/news_page_gerb_article.e03654ed.jpg";